<template>
  <LinkText
    v-bind="$attrs"
    as="button"
    type="button"
    ref="trigger"
    :class="inDropdown ? 'hover:bg-brand-blue hover:text-white' : 'text-brand-blue hover:text-brand-blue-light'">
    <DocumentDuplicateIcon
      v-if="!hideIcon"
      class="mr-1 h-5 w-5" />
    <slot />
    <BaseFlash v-model="show">{{ message }}</BaseFlash>
  </LinkText>
</template>

<script>
import { DocumentDuplicateIcon } from '@heroicons/vue/20/solid';
import ClipboardJS from 'clipboard';
import LinkText from '@/components/links/LinkText.vue';

export default {
  components: {
    LinkText,
    DocumentDuplicateIcon,
  },
  inheritAttrs: false,
  props: {
    itemName: {
      type: String,
      default: undefined,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    inDropdown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      message: 'Copied to clipboard',
    };
  },
  created() {
    if (this.itemName) {
      this.message = `${this.itemName} ${this.message.toLowerCase()}`;
    }
  },
  mounted() {
    if (!this.$refs.trigger?.$el) {
      return;
    }

    this.clipboard = new ClipboardJS(this.$refs.trigger.$el);
    this.clipboard.on('success', () => this.showMessage());
    this.clipboard.on('error', this.onError);
  },
  methods: {
    showMessage(message) {
      this.message = message || this.message;
      this.show = true;
    },

    onError(event) {
      // Take into account if it is a cut or copy action
      const actionKey = event.action === 'cut' ? 'X' : 'C';

      // Handle mac cmd key vs ctrl key
      let metaKey = 'Ctrl';
      if (navigator.platform.toLowerCase().indexOf('mac') >= 0) {
        metaKey = '⌘';
      }

      // Some versions of safari don't support copying to the clipboard. But they do allow for selecting some text.
      this.showMessage(`Press ${metaKey}-${actionKey} to ${event.action}`);
    },
  },
};
</script>
